module.exports = __webpack_public_path__ + "img/savings-body-bg.1550cedf.png";